const states = [
    { value: 1, name: '闲置' },
    { value: 2, name: '使用中' },
    { value: 3, name: '审批中' },
    { value: 4, name: '借用中' },
    { value: 5, name: '已处置' },
]

const getName = (state) => {
    const item = states.find(item => {
        return state == item.value;
    })

    return item.name;
}

export {
    states,
    getName
}